export default "__VITE_ASSET__CHfwQmTj__"